import React from "react";

import MuiCheckbox, { CheckboxProps } from "@mui/material/Checkbox";

import styles from "./CheckboxV2.module.css";

// NOTE: this is a bare bones variant of our Checkbox
const CheckboxV2: React.FC<CheckboxProps> = ({
  checked,
  disabled,
  ...restProps
}) => {
  return (
    <MuiCheckbox
      classes={{
        root: styles.root,
        checked: styles.checked,
        disabled: styles.disabled,
      }}
      checked={checked}
      disabled={disabled}
      {...restProps}
    />
  );
};

export default CheckboxV2;
